import { ApolloLink } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import {
  getFriendlyUploadNetworkErrorMessage,
  isUploadPayloadTooLargeNetworkError,
} from './uploadNetworkError.util';

/**
 * Apollo link: for the UploadFile mutation only, show a friendly message when the
 * transport rejects the body (e.g. HTTP 413). Pass a notifier that matches your UI (toast, etc.).
 */
export function createUploadFileNetworkErrorLink(
  notify: (message: string) => void,
): ApolloLink {
  return onError(({ operation, networkError }) => {
    if (operation.operationName !== 'UploadFile' || !networkError) {
      return;
    }
    if (!isUploadPayloadTooLargeNetworkError(networkError)) {
      return;
    }
    notify(getFriendlyUploadNetworkErrorMessage(networkError));
  });
}
